import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  OrderEntity,
  PlaceDirectSaleOrderBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiPlaceOrderDirectSale = (
    placeDirectSaleOrderBodyDto: MaybeRef<PlaceDirectSaleOrderBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      placeDirectSaleOrderBodyDto = unref(placeDirectSaleOrderBodyDto);
      
      return fetchApiInstance<OrderEntity>(
      {url: `/orders/directSale`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placeDirectSaleOrderBodyDto
    },
      options);
    }
  


export const getApiPlaceOrderDirectSaleMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderDirectSale>>, TError,{data: BodyType<PlaceDirectSaleOrderBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderDirectSale>>, TError,{data: BodyType<PlaceDirectSaleOrderBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPlaceOrderDirectSale>>, {data: BodyType<PlaceDirectSaleOrderBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPlaceOrderDirectSale(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPlaceOrderDirectSaleMutationResult = NonNullable<Awaited<ReturnType<typeof apiPlaceOrderDirectSale>>>
    export type ApiPlaceOrderDirectSaleMutationBody = BodyType<PlaceDirectSaleOrderBodyDto>
    export type ApiPlaceOrderDirectSaleMutationError = ErrorType<BackendErrorEntity>

    export const useApiPlaceOrderDirectSale = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderDirectSale>>, TError,{data: BodyType<PlaceDirectSaleOrderBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPlaceOrderDirectSale>>,
        TError,
        {data: BodyType<PlaceDirectSaleOrderBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPlaceOrderDirectSaleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    